// extracted by mini-css-extract-plugin
export var activeDot = "_2l-c";
export var buttonContainer = "_2l-9";
export var channelButton = "_2l-a";
export var clickable = "_2l-d";
export var content = "_2l-0";
export var contentFull = "_2l-2";
export var contentThird = "_2l-1";
export var contentWrapper = "_2l-7";
export var description = "_2l-5";
export var heightShort = "_2l-f";
export var image = "_2l-3";
export var imageContainer = "_2l-4";
export var selectButton = "_2l-e";
export var spinnerContainer = "_2l-b";
export var titleContent = "_2l-8";
export var titleWrapper = "_2l-6";